/* eslint-disable no-nested-ternary */
import React, { useCallback } from "react";
import Chart from "react-apexcharts";
import { Box, useTheme, Skeleton } from "@mui/material";
import { UseDashboardContext } from "src/context/dashboard";
import NoRecordFound from "src/components/shared/molecules/NoRecordFound";
import useStyles from "./Styles";

type ChatData = {
  count: number;
  date: string;
  pageId: string;
  pageName: string;
  source: "facebook" | "whatsapp" | "instagram" | "widget";
};

const ChatStatistics = () => {
  const { classes } = useStyles();

  const theme = useTheme();

  const contextData = UseDashboardContext();
  let totalChatsGraphDataLoading: boolean = false;
  let totalChatsGraphData: any;
  if (contextData) {
    ({ totalChatsGraphData, totalChatsGraphDataLoading } = contextData);
  }

  const sums = totalChatsGraphData.reduce(
    (
      acc: {
        facebook: number;
        whatsapp: number;
        instagram: number;
        chatbot: number;
      },
      item: ChatData,
    ) => {
      const { source, count } = item;
      const key = source === "widget" ? "chatbot" : source;
      acc[key] = (acc[key] || 0) + count;
      return acc;
    },
    { facebook: 0, whatsapp: 0, instagram: 0, chatbot: 0 },
  );

  const series = [sums.facebook, sums.whatsapp, sums.instagram, sums.chatbot];

  const seriesSummedCount = useCallback(() => {
    const sum = series.reduce((access, item) => {
      return access + item;
    }, 0);
    return sum;
  }, [series]);

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "donut",
    },
    labels: ["FB", "WA", "IG", "Bot"],
    colors: ["#1877F2", "#60D669", "#B336AA", "#FF9800"],
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter(val, opts) {
        const label = opts.w.globals.labels[opts.seriesIndex];
        const value = opts.w.globals.series[opts.seriesIndex];
        return `${value} \n${label}`;
      },
      style: {
        fontSize: "16px",
        fontFamily: "Poppins",
        fontWeight: 500,
      },
      offsetY: 0,
      dropShadow: {
        enabled: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "0%", // full pie
        },
      },
    },
    stroke: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  };

  return (
    <Box className={classes.chatStaticsRoot}>
      <Box
        sx={{
          width: 320,
          height: 320,
          [theme.breakpoints.down("sm")]: {
            width: 300,
            height: 300,
          },
        }}
      >
        {totalChatsGraphDataLoading ? (
          <Box className={classes.skeletonBox}>
            <Skeleton variant="circular" width={150} height={150} />
          </Box>
        ) : seriesSummedCount() === 0 ? (
          <NoRecordFound />
        ) : (
          <Chart
            options={options}
            series={series}
            type="donut"
            width="100%" // 👈 Match parent's width
            height="100%" // 👈 Match parent's height
          />
        )}
      </Box>
    </Box>
  );
};

export default ChatStatistics;
